import apiClient from './api';

export const getNewsletters = async ({ limit = 20, offset = 0 } = {}) => {
  const response = await apiClient.get('/api/newsletters', { params: { limit, offset } });
  return response.data;
};

export const getNewsletter = async (id) => {
  // 120s: server-side render of large structured_draft can be slow under load
  const response = await apiClient.get(`/api/newsletters/${id}`, { timeout: 120000 });
  return response.data;
};

export const createNewsletter = async (body) => {
  const response = await apiClient.post('/api/newsletters', body);
  return response.data;
};

export const deleteNewsletter = async (id) => {
  await apiClient.delete(`/api/newsletters/${id}`);
};

export const getPresets = async () => {
  const response = await apiClient.get('/api/newsletter-presets');
  return response.data;
};
